import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { id: "blog-section" }
const _hoisted_2 = { class: "jumbotron jumbotron-fluid bg2 m-0 pt-5" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "col-12 text-center pt-5" }
const _hoisted_5 = {
  key: 0,
  class: "loading"
}
const _hoisted_6 = { class: "maincontent" }
const _hoisted_7 = ["id"]
const _hoisted_8 = { class: "col-12 text-center" }
const _hoisted_9 = { class: "project_header" }
const _hoisted_10 = {
  key: 0,
  class: "loading"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_center = _resolveComponent("center")!
  const _component_PortfolioSegment = _resolveComponent("PortfolioSegment")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[2] || (_cache[2] = _createElementVNode("h1", null, "Portfolio", -1)),
          _cache[3] || (_cache[3] = _createElementVNode("hr", null, null, -1)),
          (_ctx.loading_main)
            ? (_openBlock(), _createElementBlock("h2", _hoisted_5, [
                _createVNode(_component_center, null, {
                  default: _withCtx(() => _cache[1] || (_cache[1] = [
                    _createTextVNode("Loading Data...")
                  ])),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categorys, (category, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "row project_container",
              id: category.name,
              key: category._id
            }, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("h3", _hoisted_9, _toDisplayString(category.name), 1),
                _createVNode(_component_center, null, {
                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createElementVNode("hr", { class: "sethr" }, null, -1)
                  ])),
                  _: 1
                })
              ]),
              (_ctx.loadings[index])
                ? (_openBlock(), _createElementBlock("h2", _hoisted_10, [
                    _createVNode(_component_center, null, {
                      default: _withCtx(() => _cache[5] || (_cache[5] = [
                        _createTextVNode("Loading Data...")
                      ])),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_PortfolioSegment, {
                cat: category._id,
                index: index,
                onChangeload: _cache[0] || (_cache[0] = ($event: any) => (_ctx.ChangeL($event)))
              }, null, 8, ["cat", "index"])
            ], 8, _hoisted_7))
          }), 128))
        ]),
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "col-12 text-center" }, [
          _createElementVNode("br"),
          _createElementVNode("br")
        ], -1))
      ])
    ])
  ]))
}